<ng-container *rxIf="viewModel.hasRange$ | push; else SinglePrice">
  <div
    class="shelf-talker-price"
    appPrintCardScaleDownText
    [lineHeightScaleVsFontSize]="lineHeightScaleVsFontSize"
    [adjustLineHeight]="adjustLineHeight"
    [maxWidthInPx]="maxWidthInPx"
    [maxHeightInPx]="maxWidthInPx"
    [transparentWhileScaling]="transparentWhileScaling">
    <span
      class="dollar-sign"
      [ngClass]="{
        'force-bold-style': (viewModel.minPriceOnSale$ | push) && (viewModel.salePriceForceBold$ | push),
        'force-italic-style': (viewModel.minPriceOnSale$ | push) && (viewModel.salePriceForceItalic$ | push)
      }"
      [ngStyle]="{
        color: (viewModel.minPriceOnSale$ | push) ? (viewModel.saleLabelFontColor$ | push) : null,
        'text-decoration-color': (viewModel.minPriceOnSale$ | push) ? (viewModel.saleLabelFontColor$ | push) : null,
        'text-decoration': (viewModel.minPriceOnSale$ | push) ? (viewModel.saleTextDecoration$ | push) : null
      }">
      $
    </span>
    <span
      class="price-integer"
      [ngClass]="{
        'force-bold-style': (viewModel.minPriceOnSale$ | push) && (viewModel.salePriceForceBold$ | push),
        'force-italic-style': (viewModel.minPriceOnSale$ | push) && (viewModel.salePriceForceItalic$ | push)
      }"
      [ngStyle]="{
        color: (viewModel.minPriceOnSale$ | push) ? (viewModel.saleLabelFontColor$ | push) : null,
        'text-decoration-color': (viewModel.minPriceOnSale$ | push) ? (viewModel.saleLabelFontColor$ | push) : null,
        'text-decoration': (viewModel.minPriceOnSale$ | push) ? (viewModel.saleTextDecoration$ | push) : null
      }">
      {{ viewModel.minPriceInteger$ | push }}
    </span>
    <span
      class="price-decimal"
      [ngClass]="{
        'force-bold-style': (viewModel.minPriceOnSale$ | push) && (viewModel.salePriceForceBold$ | push),
        'force-italic-style': (viewModel.minPriceOnSale$ | push) && (viewModel.salePriceForceItalic$ | push)
      }"
      [ngStyle]="{
        color: (viewModel.minPriceOnSale$ | push) ? (viewModel.saleLabelFontColor$ | push) : null,
        'text-decoration-color': (viewModel.minPriceOnSale$ | push) ? (viewModel.saleLabelFontColor$ | push) : null,
        'text-decoration': (viewModel.minPriceOnSale$ | push) ? (viewModel.saleTextDecoration$ | push) : null
      }">
      {{ viewModel.minPriceDecimal$ | push }}
    </span>
    <span class="price-range-divider">-</span>
    <span
      class="dollar-sign"
      [ngClass]="{
        'force-bold-style': (viewModel.maxPriceOnSale$ | push) && (viewModel.salePriceForceBold$ | push),
        'force-italic-style': (viewModel.maxPriceOnSale$ | push) && (viewModel.salePriceForceItalic$ | push)
      }"
      [ngStyle]="{
        color: (viewModel.maxPriceOnSale$ | push) ? (viewModel.saleLabelFontColor$ | push) : null,
        'text-decoration-color': (viewModel.maxPriceOnSale$ | push) ? (viewModel.saleLabelFontColor$ | push) : null,
        'text-decoration': (viewModel.maxPriceOnSale$ | push) ? (viewModel.saleTextDecoration$ | push) : null
      }">
      $
    </span>
    <span
      class="price-integer"
      [ngClass]="{
        'force-bold-style': (viewModel.maxPriceOnSale$ | push) && (viewModel.salePriceForceBold$ | push),
        'force-italic-style': (viewModel.maxPriceOnSale$ | push) && (viewModel.salePriceForceItalic$ | push)
      }"
      [ngStyle]="{
        color: (viewModel.maxPriceOnSale$ | push) ? (viewModel.saleLabelFontColor$ | push) : null,
        'text-decoration-color': (viewModel.maxPriceOnSale$ | push) ? (viewModel.saleLabelFontColor$ | push) : null,
        'text-decoration': (viewModel.maxPriceOnSale$ | push) ? (viewModel.saleTextDecoration$ | push) : null
      }">
      {{ viewModel.maxPriceInteger$ | push }}
    </span>
    <span
      class="price-decimal"
      [ngClass]="{
        'force-bold-style': (viewModel.maxPriceOnSale$ | push) && (viewModel.salePriceForceBold$ | push),
        'force-italic-style': (viewModel.maxPriceOnSale$ | push) && (viewModel.salePriceForceItalic$ | push)
      }"
      [ngStyle]="{
        color: (viewModel.maxPriceOnSale$ | push) ? (viewModel.saleLabelFontColor$ | push) : null,
        'text-decoration-color': (viewModel.maxPriceOnSale$ | push) ? (viewModel.saleLabelFontColor$ | push) : null,
        'text-decoration': (viewModel.maxPriceOnSale$ | push) ? (viewModel.saleTextDecoration$ | push) : null
      }">
      {{ viewModel.maxPriceDecimal$ | push }}
    </span>
  </div>
</ng-container>
<ng-template #SinglePrice>
  <div
    class="shelf-talker-price"
    appPrintCardScaleDownText
    [maxWidthInPx]="maxWidthInPx"
    [maxHeightInPx]="maxWidthInPx"
    [transparentWhileScaling]="true">
    <span
      class="dollar-sign"
      [ngClass]="{
        'force-bold-style': (viewModel.maxPriceOnSale$ | push) && (viewModel.salePriceForceBold$ | push),
        'force-italic-style': (viewModel.maxPriceOnSale$ | push) && (viewModel.salePriceForceItalic$ | push)
      }"
      [ngStyle]="{
        color: (viewModel.maxPriceOnSale$ | push) ? (viewModel.saleLabelFontColor$ | push) : null,
        'text-decoration-color': (viewModel.maxPriceOnSale$ | push) ? (viewModel.saleLabelFontColor$ | push) : null,
        'text-decoration': (viewModel.maxPriceOnSale$ | push) ? (viewModel.saleTextDecoration$ | push) : null
      }">
      $
    </span>
    <span
      class="price-integer"
      [ngClass]="{
        'force-bold-style': (viewModel.maxPriceOnSale$ | push) && (viewModel.salePriceForceBold$ | push),
        'force-italic-style': (viewModel.maxPriceOnSale$ | push) && (viewModel.salePriceForceItalic$ | push)
      }"
      [ngStyle]="{
        color: (viewModel.maxPriceOnSale$ | push) ? (viewModel.saleLabelFontColor$ | push) : null,
        'text-decoration-color': (viewModel.maxPriceOnSale$ | push) ? (viewModel.saleLabelFontColor$ | push) : null,
        'text-decoration': (viewModel.maxPriceOnSale$ | push) ? (viewModel.saleTextDecoration$ | push) : null
      }">
      {{ viewModel.maxPriceInteger$ | push }}
    </span>
    <span
      class="price-decimal"
      [ngClass]="{
        'force-bold-style': (viewModel.maxPriceOnSale$ | push) && (viewModel.salePriceForceBold$ | push),
        'force-italic-style': (viewModel.maxPriceOnSale$ | push) && (viewModel.salePriceForceItalic$ | push)
      }"
      [ngStyle]="{
        color: (viewModel.maxPriceOnSale$ | push) ? (viewModel.saleLabelFontColor$ | push) : null,
        'text-decoration-color': (viewModel.maxPriceOnSale$ | push) ? (viewModel.saleLabelFontColor$ | push) : null,
        'text-decoration': (viewModel.maxPriceOnSale$ | push) ? (viewModel.saleTextDecoration$ | push) : null
      }">
      {{ viewModel.maxPriceDecimal$ | push }}
    </span>
  </div>
</ng-template>
